<!-- ═══════════════════════════════════════════════════════════════
     FikoDFM Component - Starfield HUD Style
     Glass Morphism + Cyan Glow + Professional CAD Analysis Panel
     ═══════════════════════════════════════════════════════════════ -->

<!-- TOOLBAR -->
<div class="dfm-toolbar">
    <button class="tab-btn"
            [class.active]="dfmViewMode==='Sonuc'"
            title="Genel Bakis"
            (click)="dfmViewMode='Sonuc';CD.detectChanges();">
        <i class="icon chart pie"></i> Sonuc
    </button>

    <button class="tab-btn"
            [class.active]="dfmViewMode==='Liste'"
            title="Sorunlar Listesi"
            (click)="dfmViewMode='Liste';CD.detectChanges();">
        <i class="icon list"></i> Liste
    </button>

    <button class="tab-btn"
            [class.active]="dfmViewMode==='Maliyet'"
            title="Maliyet Analizi"
            (click)="dfmViewMode='Maliyet';CD.detectChanges();">
        <i class="icon dollar sign"></i> Maliyet
    </button>

    <div class="toolbar-spacer"></div>

    <!-- Mevcut Secimi Al -->
    <button class="action-btn accent-purple"
            title="Sahnedeki mevcut secimi al"
            (click)="mevcutSecimiAl()">
        <i class="icon download"></i>
    </button>

    <!-- Analiz Baslat -->
    <button class="action-btn primary"
            [class.loading]="isAnalyzing"
            [disabled]="isAnalyzing || !seciliAktifParca"
            [title]="seciliAktifParca ? 'Analiz Et: ' + seciliAktifParcaIsim : 'Once bir parca secin'"
            (click)="seciliParcayiAnalizEt()">
        <i class="icon bolt"></i>
    </button>

    <!-- Ayarlar -->
    <button class="tab-btn"
            [class.active]="dfmViewMode==='Ayarlar'"
            title="Ayarlar"
            (click)="dfmViewMode='Ayarlar';CD.detectChanges();">
        <i class="icon cog"></i>
    </button>
</div>

<!-- STATUS BAR -->
<div class="status-bar">
    <span class="gpu-badge"
          [class.gpu]="gpuMode === 'WEBGPU'"
          [class.wasm]="gpuMode === 'WASM'"
          [class.cpu]="gpuMode === 'CPU'">
        {{ gpuMode === 'WEBGPU' ? 'GPU' : gpuMode === 'WASM' ? 'WASM' : 'CPU' }}
    </span>
    <span *ngIf="currentReport" class="score-badge">
        Skor: <strong [style.color]="getScoreColor(currentReport.overallScore)">{{ currentReport.overallScore }}</strong>/100
    </span>
</div>

<!-- PART SELECTOR -->
<div class="part-selector">
    <div class="selector-row">
        <button class="select-btn"
                [class.active]="parcaSecModu"
                (click)="parcaSecModuToggle()"
                [title]="parcaSecModu ? 'Secim modunu kapat' : 'Sahneden parca sec'">
            <i class="icon crosshairs"></i>
            {{ parcaSecModu ? 'Seciliyor...' : 'Sec' }}
        </button>

        <div class="part-name" [class.has-part]="seciliAktifParca" [class.no-part]="!seciliAktifParca">
            <i class="icon cube"></i>
            <span>{{ seciliAktifParcaIsim }}</span>
        </div>

        <button *ngIf="seciliAktifParca"
                class="clear-btn"
                title="Secimi temizle"
                (click)="seciliParcayiTemizle()">
            <i class="icon close"></i>
        </button>
    </div>

    <div *ngIf="parcaSecModu" class="selection-hint">
        <i class="icon hand pointer"></i>
        Sahneden analiz edilecek parcaya tiklayin
    </div>
</div>

<!-- PROGRESS -->
<div *ngIf="isAnalyzing && progressPercent > 0" class="progress-panel">
    <div class="progress-header">
        <i class="icon spinner"></i>
        <span class="progress-text">{{ progressMessage }}</span>
        <span class="progress-pct">%{{ progressPercent }}</span>
    </div>
    <div class="progress-track">
        <div class="progress-fill" [style.width.%]="progressPercent"></div>
    </div>
</div>

<!-- ERROR -->
<div *ngIf="hataMesaji" class="error-msg">
    <i class="icon exclamation triangle"></i>
    {{ hataMesaji }}
</div>

<!-- ═══════════════════════════════════════════════════
     SONUC (Results) TAB
     ═══════════════════════════════════════════════════ -->
<div [style.display]="dfmViewMode==='Sonuc' ? 'block':'none'" class="dfm-content">

    <!-- Empty State -->
    <div *ngIf="!currentReport" class="empty-state">
        <i class="icon flask"></i>
        <div class="empty-title">ANALIZ BEKLENIYOR</div>
        <div class="empty-hint">Parca secin ve analiz baslatin</div>
    </div>

    <div *ngIf="currentReport">

        <!-- Circular Score Gauge -->
        <div class="score-gauge-container">
            <div class="score-gauge">
                <svg viewBox="0 0 100 100">
                    <circle class="gauge-bg" cx="50" cy="50" r="42"></circle>
                    <circle class="gauge-fill"
                            cx="50" cy="50" r="42"
                            [attr.stroke]="getScoreColor(currentReport.overallScore)"
                            [attr.stroke-dasharray]="263.9"
                            [attr.stroke-dashoffset]="263.9 - (263.9 * currentReport.overallScore / 100)"
                            [style.--gauge-glow]="getScoreColor(currentReport.overallScore)">
                    </circle>
                </svg>
                <div class="gauge-center">
                    <div class="gauge-value" [style.color]="getScoreColor(currentReport.overallScore)">
                        {{ currentReport.overallScore }}
                    </div>
                    <div class="gauge-label">SKOR</div>
                    <div class="gauge-rating" [style.color]="getScoreColor(currentReport.overallScore)">
                        {{ getRatingText(currentReport.manufacturabilityRating) }}
                    </div>
                </div>
            </div>
        </div>

        <!-- Process Selector -->
        <div class="process-selector">
            <span class="process-label">PROSES</span>
            <select [(ngModel)]="ayarlar.secilenProses"
                    (ngModelChange)="prosesDegisenAnaliz($event)">
                <option *ngFor="let p of prosesSecenekleri; trackBy: trackByValue" [value]="p.value">{{ p.label }}</option>
            </select>
        </div>

        <!-- Process-Geometry Incompatibility Warning -->
        <div *ngIf="currentReport.scores.processGeometryFit < 50"
             class="process-warning-banner"
             [class.severity-critical]="currentReport.scores.processGeometryFit < 30"
             [class.severity-warning]="currentReport.scores.processGeometryFit >= 30">
            <span class="warning-icon">&#9888;</span>
            <span class="warning-text" *ngIf="currentReport.scores.processGeometryFit < 30">
                PROSES UYUMSUZLUK: Bu parca secilen proses icin uygun degil!
            </span>
            <span class="warning-text" *ngIf="currentReport.scores.processGeometryFit >= 30">
                UYARI: Parca geometrisi secilen prosesle kismi uyumlu (Uyum: %{{ currentReport.scores.processGeometryFit }})
            </span>
        </div>

        <!-- Stats Row -->
        <div class="stats-row">
            <div class="stat-card critical">
                <span class="stat-count">{{ currentReport.criticalIssues.length }}</span>
                <span class="stat-name">KRITIK</span>
            </div>
            <div class="stat-card warning">
                <span class="stat-count">{{ currentReport.warnings.length }}</span>
                <span class="stat-name">UYARI</span>
            </div>
            <div class="stat-card info">
                <span class="stat-count">{{ currentReport.suggestions.length }}</span>
                <span class="stat-name">BILGI</span>
            </div>
            <div class="stat-card pass">
                <span class="stat-count">{{ currentReport.passed.length }}</span>
                <span class="stat-name">UYGUN</span>
            </div>
        </div>

        <!-- Score Bars -->
        <div class="section-divider">
            <div class="section-line"></div>
            <span class="section-title">DETAYLI SKORLAR</span>
            <div class="section-line"></div>
        </div>

        <div class="score-bars">
            <div class="score-row" *ngFor="let s of scoreItems; trackBy: trackByCategory">
                <span class="score-label">{{ s.label }}</span>
                <div class="score-bar">
                    <div class="score-fill"
                         [style.width.%]="currentReport.scores[s.key]"
                         [style.background]="getScoreColor(currentReport.scores[s.key])"></div>
                </div>
                <span class="score-value">{{ currentReport.scores[s.key] }}</span>
            </div>
        </div>

        <!-- Recommendations -->
        <div *ngIf="currentReport.topRecommendations.length > 0">
            <div class="section-divider">
                <div class="section-line"></div>
                <span class="section-title">ONERILER</span>
                <div class="section-line"></div>
            </div>
            <div class="recommendations">
                <div *ngFor="let rec of currentReport.topRecommendations.slice(0, 3); let i = index; trackBy: trackByIndex"
                     class="rec-item">
                    <span class="rec-num">{{ i + 1 }}.</span>
                    {{ rec }}
                </div>
            </div>
        </div>
    </div>
</div>

<!-- ═══════════════════════════════════════════════════
     LISTE (Issues) TAB
     ═══════════════════════════════════════════════════ -->
<div [style.display]="dfmViewMode==='Liste' ? 'block':'none'" class="dfm-content">

    <div *ngIf="!currentReport" class="empty-state">
        <i class="icon list"></i>
        <div class="empty-title">LISTE BOS</div>
        <div class="empty-hint">Once analiz yapin</div>
    </div>

    <div *ngIf="currentReport">
        <!-- Critical -->
        <div *ngIf="ayarlar.gosterKritik && currentReport.criticalIssues.length > 0" class="issue-section">
            <div class="section-header critical">
                <i class="icon close circle"></i>
                Kritik
                <span class="issue-count">{{ currentReport.criticalIssues.length }}</span>
            </div>
            <div *ngFor="let issue of currentReport.criticalIssues; trackBy: trackByIndex"
                 class="issue-item critical"
                 [class.selected]="selectedIssue?.id === issue.id"
                 (click)="onIssueSelected(issue)">
                <div class="issue-title">{{ issue.title }}</div>
                <div class="issue-desc">{{ issue.description }}</div>
            </div>
        </div>

        <!-- Warning -->
        <div *ngIf="ayarlar.gosterUyari && currentReport.warnings.length > 0" class="issue-section">
            <div class="section-header warning">
                <i class="icon warning sign"></i>
                Uyari
                <span class="issue-count">{{ currentReport.warnings.length }}</span>
            </div>
            <div *ngFor="let issue of currentReport.warnings; trackBy: trackByIndex"
                 class="issue-item warning"
                 [class.selected]="selectedIssue?.id === issue.id"
                 (click)="onIssueSelected(issue)">
                <div class="issue-title">{{ issue.title }}</div>
                <div class="issue-desc">{{ issue.description }}</div>
            </div>
        </div>

        <!-- Info -->
        <div *ngIf="ayarlar.gosterBilgi && currentReport.suggestions.length > 0" class="issue-section">
            <div class="section-header info">
                <i class="icon info circle"></i>
                Bilgi
                <span class="issue-count">{{ currentReport.suggestions.length }}</span>
            </div>
            <div *ngFor="let issue of currentReport.suggestions; trackBy: trackByIndex"
                 class="issue-item info"
                 [class.selected]="selectedIssue?.id === issue.id"
                 (click)="onIssueSelected(issue)">
                <div class="issue-title">{{ issue.title }}</div>
                <div class="issue-desc">{{ issue.description }}</div>
            </div>
        </div>

        <!-- Pass -->
        <div *ngIf="ayarlar.gosterUygun && currentReport.passed.length > 0" class="issue-section">
            <div class="section-header pass">
                <i class="icon check circle"></i>
                Uygun
                <span class="issue-count">{{ currentReport.passed.length }}</span>
            </div>
            <div *ngFor="let issue of currentReport.passed; trackBy: trackByIndex"
                 class="issue-item pass"
                 [class.selected]="selectedIssue?.id === issue.id"
                 (click)="onIssueSelected(issue)">
                <div class="issue-title">{{ issue.title }}</div>
                <div class="issue-desc">{{ issue.description }}</div>
            </div>
        </div>
    </div>
</div>

<!-- ═══════════════════════════════════════════════════
     MALIYET (Cost) TAB - Fizik Bazli Maliyet Motoru
     ═══════════════════════════════════════════════════ -->
<div [style.display]="dfmViewMode==='Maliyet' ? 'block':'none'" class="dfm-content">

    <div *ngIf="!currentReport" class="empty-state">
        <i class="icon dollar sign"></i>
        <div class="empty-title">MALIYET BEKLENIYOR</div>
        <div class="empty-hint">Once analiz yapin</div>
    </div>

    <div *ngIf="currentReport">

        <!-- ── BOLUM A: OZET ── -->
        <div class="cost-summary-grid">
            <div class="cost-summary-card">
                <span class="cost-summary-label">PARCA/ADET</span>
                <span class="cost-summary-value accent-cyan">
                    {{ paraBirimiSimge }}{{ (currentReport.costEstimate.bestCostPerPart || currentReport.costEstimate.currentCost).toFixed(2) }}
                </span>
            </div>
            <div class="cost-summary-card">
                <span class="cost-summary-label">PARTI (x{{ ayarlar.batchSize }})</span>
                <span class="cost-summary-value accent-blue">
                    {{ paraBirimiSimge }}{{ ((currentReport.costEstimate.bestCostPerPart || currentReport.costEstimate.currentCost) * ayarlar.batchSize).toFixed(0) }}
                </span>
            </div>
            <div class="cost-summary-card">
                <span class="cost-summary-label">AGIRLIK</span>
                <span class="cost-summary-value">
                    {{ (currentReport.costEstimate.partWeightKg || 0).toFixed(3) }} kg
                </span>
            </div>
            <div class="cost-summary-card">
                <span class="cost-summary-label">FIZIBILITE</span>
                <span class="cost-summary-value">
                    <span class="feasibility-dot"
                          [class.green]="currentReport.costEstimate.feasibility === 'green'"
                          [class.yellow]="currentReport.costEstimate.feasibility === 'yellow'"
                          [class.red]="currentReport.costEstimate.feasibility === 'red'"></span>
                    {{ currentReport.costEstimate.feasibility === 'green' ? 'UYGUN' : currentReport.costEstimate.feasibility === 'yellow' ? 'KOSULLU' : 'ZOR' }}
                </span>
            </div>
        </div>

        <!-- Onerilen proses banner -->
        <div *ngIf="currentReport.costEstimate.recommendedProcessTR" class="recommended-process-banner">
            <span class="rp-label">ONERILEN:</span>
            <span class="rp-value">{{ currentReport.costEstimate.recommendedProcessTR }}</span>
            <span *ngIf="currentReport.costEstimate.bestCostPerPart" class="rp-cost">
                {{ paraBirimiSimge }}{{ currentReport.costEstimate.bestCostPerPart.toFixed(2) }}/parca
            </span>
        </div>

        <!-- ── BOLUM B: MALIYET DAGILIMI (CostEngine) ── -->
        <div *ngIf="currentReport.costEstimate.detailedResult?.breakdown as bd">
            <div class="section-divider">
                <div class="section-line"></div>
                <span class="section-title">MALIYET DAGILIMI</span>
                <div class="section-line"></div>
            </div>

            <div class="cost-breakdown">
                <div class="cost-row" *ngIf="bd.materialCost > 0">
                    <span class="cost-name">Malzeme</span>
                    <div class="cost-bar"><div class="cost-fill fill-material" [style.width.%]="(bd.materialCost / bd.totalPerPart) * 100"></div></div>
                    <span class="cost-value">{{ paraBirimiSimge }}{{ bd.materialCost.toFixed(2) }}</span>
                </div>
                <div class="cost-row" *ngIf="bd.laborCost > 0">
                    <span class="cost-name">Iscilik</span>
                    <div class="cost-bar"><div class="cost-fill fill-labor" [style.width.%]="(bd.laborCost / bd.totalPerPart) * 100"></div></div>
                    <span class="cost-value">{{ paraBirimiSimge }}{{ bd.laborCost.toFixed(2) }}</span>
                </div>
                <div class="cost-row" *ngIf="bd.machineCost > 0">
                    <span class="cost-name">Makine</span>
                    <div class="cost-bar"><div class="cost-fill fill-machining" [style.width.%]="(bd.machineCost / bd.totalPerPart) * 100"></div></div>
                    <span class="cost-value">{{ paraBirimiSimge }}{{ bd.machineCost.toFixed(2) }}</span>
                </div>
                <div class="cost-row" *ngIf="bd.toolingCost > 0">
                    <span class="cost-name">Takim/Kalip</span>
                    <div class="cost-bar"><div class="cost-fill fill-tooling" [style.width.%]="(bd.toolingCost / bd.totalPerPart) * 100"></div></div>
                    <span class="cost-value">{{ paraBirimiSimge }}{{ bd.toolingCost.toFixed(2) }}</span>
                </div>
                <div class="cost-row" *ngIf="bd.setupCost > 0">
                    <span class="cost-name">Setup</span>
                    <div class="cost-bar"><div class="cost-fill fill-setup" [style.width.%]="(bd.setupCost / bd.totalPerPart) * 100"></div></div>
                    <span class="cost-value">{{ paraBirimiSimge }}{{ bd.setupCost.toFixed(2) }}</span>
                </div>
                <div class="cost-row" *ngIf="bd.postProcessingCost > 0">
                    <span class="cost-name">Son Islem</span>
                    <div class="cost-bar"><div class="cost-fill fill-postprocess" [style.width.%]="(bd.postProcessingCost / bd.totalPerPart) * 100"></div></div>
                    <span class="cost-value">{{ paraBirimiSimge }}{{ bd.postProcessingCost.toFixed(2) }}</span>
                </div>
                <div class="cost-row" *ngIf="bd.qualityControlCost > 0">
                    <span class="cost-name">Kalite K.</span>
                    <div class="cost-bar"><div class="cost-fill fill-quality" [style.width.%]="(bd.qualityControlCost / bd.totalPerPart) * 100"></div></div>
                    <span class="cost-value">{{ paraBirimiSimge }}{{ bd.qualityControlCost.toFixed(2) }}</span>
                </div>
                <div class="cost-row" *ngIf="bd.overheadCost > 0">
                    <span class="cost-name">Overhead</span>
                    <div class="cost-bar"><div class="cost-fill fill-overhead" [style.width.%]="(bd.overheadCost / bd.totalPerPart) * 100"></div></div>
                    <span class="cost-value">{{ paraBirimiSimge }}{{ bd.overheadCost.toFixed(2) }}</span>
                </div>
                <div class="cost-row" *ngIf="bd.profitAmount > 0">
                    <span class="cost-name">Kar (%{{ bd.profitMargin }})</span>
                    <div class="cost-bar"><div class="cost-fill fill-profit" [style.width.%]="(bd.profitAmount / bd.totalPerPart) * 100"></div></div>
                    <span class="cost-value">{{ paraBirimiSimge }}{{ bd.profitAmount.toFixed(2) }}</span>
                </div>

                <!-- Custom Items -->
                <div class="cost-row" *ngFor="let ci of ayarlar.customCostItems; trackBy: trackByIndex">
                    <span class="cost-name" [class.disabled-item]="!ci.enabled">{{ ci.name }}</span>
                    <div class="cost-bar"><div class="cost-fill fill-custom" *ngIf="ci.enabled" [style.width.%]="(ci.costPerPart / bd.totalPerPart) * 100"></div></div>
                    <span class="cost-value" [class.disabled-item]="!ci.enabled">{{ ci.enabled ? paraBirimiSimge + ci.costPerPart.toFixed(2) : '-' }}</span>
                </div>

                <!-- TOPLAM -->
                <div class="cost-total-row">
                    <span class="cost-name">TOPLAM</span>
                    <span class="cost-total-value">{{ paraBirimiSimge }}{{ (currentReport.costEstimate.grandTotal || bd.totalPerPart).toFixed(2) }}</span>
                </div>
            </div>

            <!-- Detay satirlari (collapse/expand) -->
            <div class="detail-toggle" (click)="maliyetDetayAcik = !maliyetDetayAcik">
                <span>{{ maliyetDetayAcik ? 'Detaylari Gizle' : 'Detaylari Goster' }}</span>
                <i class="icon" [ngClass]="maliyetDetayAcik ? 'chevron up' : 'chevron down'"></i>
            </div>

            <div *ngIf="maliyetDetayAcik && bd.subItems?.length > 0" class="cost-detail-list">
                <div *ngFor="let item of bd.subItems; trackBy: trackByIndex" class="cost-detail-item">
                    <span class="cd-desc">{{ item.description }}</span>
                    <span class="cd-qty" *ngIf="item.quantity">x{{ item.quantity.toFixed(1) }}</span>
                    <span class="cd-unit" *ngIf="item.unitCost">&#64;{{ paraBirimiSimge }}{{ item.unitCost.toFixed(2) }}</span>
                    <span class="cd-total">{{ paraBirimiSimge }}{{ item.totalCost.toFixed(2) }}</span>
                </div>
            </div>
        </div>

        <!-- Fallback: CostEngine sonucu yoksa legacy goster -->
        <div *ngIf="!currentReport.costEstimate.detailedResult?.breakdown">
            <div class="section-divider">
                <div class="section-line"></div>
                <span class="section-title">MALIYET TAHMINI</span>
                <div class="section-line"></div>
            </div>
            <div class="cost-comparison">
                <div class="cost-card optimum">
                    <span class="cost-label">OPTIMUM</span>
                    <span class="cost-amount">{{ paraBirimiSimge }}{{ currentReport.costEstimate.baselineCost.toFixed(2) }}</span>
                    <span class="cost-unit">/parca</span>
                </div>
                <div class="cost-arrow"><i class="icon arrow right"></i></div>
                <div class="cost-card current"
                     [class.expensive]="currentReport.costEstimate.currentCost > currentReport.costEstimate.baselineCost"
                     [class.cheap]="currentReport.costEstimate.currentCost <= currentReport.costEstimate.baselineCost">
                    <span class="cost-label">MEVCUT</span>
                    <span class="cost-amount">{{ paraBirimiSimge }}{{ currentReport.costEstimate.currentCost.toFixed(2) }}</span>
                    <span class="cost-unit">/parca</span>
                </div>
            </div>
        </div>

        <!-- ── BOLUM C: PROSES KARSILASTIRMA TABLOSU ── -->
        <div *ngIf="currentReport.costEstimate.processComparisons?.length > 0">
            <div class="section-divider">
                <div class="section-line"></div>
                <span class="section-title">PROSES KARSILASTIRMA</span>
                <div class="section-line"></div>
            </div>

            <div class="process-table-container">
                <table class="process-table">
                    <thead>
                        <tr>
                            <th>Proses</th>
                            <th>{{ paraBirimiSimge }}/parca</th>
                            <th>Gun</th>
                            <th>Min</th>
                            <th>Kalite</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let pc of currentReport.costEstimate.processComparisons; trackBy: trackByIndex"
                            [class.best-row]="pc.processName === currentReport.costEstimate.recommendedProcess"
                            [class.incompatible-row]="!pc.isCompatible"
                            [class.current-process]="pc.process === ayarlar.secilenProses">
                            <td class="process-name-cell">
                                <span *ngIf="pc.processName === currentReport.costEstimate.recommendedProcess" class="best-indicator">&#9733;</span>
                                {{ pc.processNameTR || getProsesLabel(pc.process) }}
                            </td>
                            <td class="cost-cell">{{ pc.isCompatible ? paraBirimiSimge + pc.costPerPart.toFixed(2) : '-' }}</td>
                            <td>{{ pc.isCompatible ? pc.leadTimeDays : '-' }}</td>
                            <td>{{ pc.minBatchSize }}</td>
                            <td>
                                <span class="quality-badge"
                                      [class.q-high]="pc.qualityRating >= 80"
                                      [class.q-mid]="pc.qualityRating >= 50 && pc.qualityRating < 80"
                                      [class.q-low]="pc.qualityRating < 50">
                                    {{ pc.qualityRating }}
                                </span>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

    </div>
</div>

<!-- ═══════════════════════════════════════════════════
     AYARLAR (Settings) TAB
     ═══════════════════════════════════════════════════ -->
<div [style.display]="dfmViewMode==='Ayarlar' ? 'block':'none'" class="dfm-content">
    <div class="settings-panel">

        <div class="section-divider">
            <div class="section-line"></div>
            <span class="section-title">PROSES</span>
            <div class="section-line"></div>
        </div>

        <div class="setting-row">
            <span class="setting-label">Proses:</span>
            <select [(ngModel)]="ayarlar.secilenProses"
                    (ngModelChange)="prosesDegisenAnaliz($event); kaydetAyarlar(ayarlar)">
                <option *ngFor="let p of prosesSecenekleri; trackBy: trackByValue" [value]="p.value">{{ p.label }}</option>
            </select>
        </div>

        <!-- ── URETIM PARAMETRELERI ── -->
        <div class="section-divider">
            <div class="section-line"></div>
            <span class="section-title">URETIM</span>
            <div class="section-line"></div>
        </div>

        <div class="setting-row">
            <span class="setting-label">Adet:</span>
            <input type="number" class="setting-input" min="1" max="1000000"
                   [(ngModel)]="ayarlar.batchSize" (ngModelChange)="kaydetAyarlar(ayarlar)">
        </div>
        <div class="setting-row">
            <span class="setting-label">Yillik:</span>
            <input type="number" class="setting-input" min="1" max="10000000"
                   [(ngModel)]="ayarlar.annualVolume" (ngModelChange)="kaydetAyarlar(ayarlar)">
        </div>
        <div class="setting-row">
            <span class="setting-label">Tolerans:</span>
            <select [(ngModel)]="ayarlar.tightestToleranceMM" (ngModelChange)="kaydetAyarlar(ayarlar)">
                <option [ngValue]="0.01">0.01 mm</option>
                <option [ngValue]="0.05">0.05 mm</option>
                <option [ngValue]="0.1">0.10 mm</option>
                <option [ngValue]="0.5">0.50 mm</option>
                <option [ngValue]="1.0">1.00 mm</option>
            </select>
        </div>
        <div class="setting-row">
            <span class="setting-label">Yuzey Ra:</span>
            <select [(ngModel)]="ayarlar.requiredSurfaceRa" (ngModelChange)="kaydetAyarlar(ayarlar)">
                <option [ngValue]="0.4">0.4 um (Ayna)</option>
                <option [ngValue]="0.8">0.8 um</option>
                <option [ngValue]="1.6">1.6 um</option>
                <option [ngValue]="3.2">3.2 um (Standart)</option>
                <option [ngValue]="6.3">6.3 um</option>
                <option [ngValue]="12.5">12.5 um (Kaba)</option>
            </select>
        </div>

        <!-- ── MALIYET PARAMETRELERI ── -->
        <div class="section-divider">
            <div class="section-line"></div>
            <span class="section-title">MALIYET</span>
            <div class="section-line"></div>
        </div>

        <div class="setting-row">
            <span class="setting-label">Kar %:</span>
            <input type="number" class="setting-input" min="0" max="100"
                   [(ngModel)]="ayarlar.profitMarginPercent" (ngModelChange)="kaydetAyarlar(ayarlar)">
        </div>
        <div class="setting-row">
            <span class="setting-label">Overhead %:</span>
            <input type="number" class="setting-input" min="0" max="50"
                   [(ngModel)]="ayarlar.overheadPercent" (ngModelChange)="kaydetAyarlar(ayarlar)">
        </div>
        <div class="setting-row">
            <span class="setting-label">KK %:</span>
            <input type="number" class="setting-input" min="0" max="20"
                   [(ngModel)]="ayarlar.qualityControlPercent" (ngModelChange)="kaydetAyarlar(ayarlar)">
        </div>
        <div class="setting-row">
            <span class="setting-label">Birim:</span>
            <select [(ngModel)]="ayarlar.paraBirimi" (ngModelChange)="kaydetAyarlar(ayarlar)">
                <option value="USD">USD ($)</option>
                <option value="EUR">EUR (&euro;)</option>
                <option value="TRY">TRY (&#8378;)</option>
            </select>
        </div>

        <!-- ── CUSTOM MALIYET KALEMLERI ── -->
        <div class="section-divider">
            <div class="section-line"></div>
            <span class="section-title">OZEL KALEMLER</span>
            <div class="section-line"></div>
        </div>

        <!-- Mevcut custom items -->
        <div *ngFor="let ci of ayarlar.customCostItems; trackBy: trackByIndex" class="custom-item-row">
            <input type="checkbox" [checked]="ci.enabled" (change)="customItemToggle(ci.id)">
            <span class="ci-name" [class.disabled-item]="!ci.enabled">{{ ci.name }}</span>
            <span class="ci-cost">{{ paraBirimiSimge }}{{ ci.costPerPart.toFixed(2) }}</span>
            <button class="ci-delete" (click)="customItemSil(ci.id)" title="Sil">&times;</button>
        </div>

        <!-- Toplam -->
        <div *ngIf="ayarlar.customCostItems.length > 0" class="ci-total">
            Toplam: {{ paraBirimiSimge }}{{ customItemsToplam.toFixed(2) }}/parca
        </div>

        <!-- Preset butonlar -->
        <div class="ci-presets">
            <button class="preset-btn" (click)="customPresetEkle('ambalaj')">+ Ambalaj</button>
            <button class="preset-btn" (click)="customPresetEkle('nakliye')">+ Nakliye</button>
            <button class="preset-btn" (click)="customPresetEkle('montaj')">+ Montaj</button>
            <button class="preset-btn" (click)="customPresetEkle('test')">+ Test</button>
        </div>

        <!-- Yeni kalem ekleme -->
        <div class="ci-add-form">
            <input type="text" class="ci-add-name" placeholder="Kalem adi"
                   [(ngModel)]="yeniCustomItem.name">
            <input type="number" class="ci-add-cost" placeholder="$/parca" min="0" step="0.01"
                   [(ngModel)]="yeniCustomItem.costPerPart">
            <select class="ci-add-cat" [(ngModel)]="yeniCustomItem.category">
                <option value="packaging">Ambalaj</option>
                <option value="shipping">Nakliye</option>
                <option value="assembly">Montaj</option>
                <option value="testing">Test</option>
                <option value="certification">Sertifika</option>
                <option value="other">Diger</option>
            </select>
            <button class="ci-add-btn" (click)="customItemEkle()"
                    [disabled]="!yeniCustomItem.name || yeniCustomItem.costPerPart <= 0">+</button>
        </div>

        <!-- ── FILTRELER ── -->
        <div class="section-divider">
            <div class="section-line"></div>
            <span class="section-title">FILTRELER</span>
            <div class="section-line"></div>
        </div>

        <div class="check-row">
            <input type="checkbox" id="chk_kritik" [(ngModel)]="ayarlar.gosterKritik" (ngModelChange)="kaydetAyarlar(ayarlar)">
            <label for="chk_kritik" style="color: #ff5252;">Kritik Sorunlar</label>
        </div>
        <div class="check-row">
            <input type="checkbox" id="chk_uyari" [(ngModel)]="ayarlar.gosterUyari" (ngModelChange)="kaydetAyarlar(ayarlar)">
            <label for="chk_uyari" style="color: #ffab00;">Uyarilar</label>
        </div>
        <div class="check-row">
            <input type="checkbox" id="chk_bilgi" [(ngModel)]="ayarlar.gosterBilgi" (ngModelChange)="kaydetAyarlar(ayarlar)">
            <label for="chk_bilgi" style="color: #00e5ff;">Bilgi</label>
        </div>
        <div class="check-row">
            <input type="checkbox" id="chk_uygun" [(ngModel)]="ayarlar.gosterUygun" (ngModelChange)="kaydetAyarlar(ayarlar)">
            <label for="chk_uygun" style="color: #00e676;">Uygun Olanlar</label>
        </div>

        <!-- ── RAPOR ── -->
        <div class="section-divider">
            <div class="section-line"></div>
            <span class="section-title">RAPOR</span>
            <div class="section-line"></div>
        </div>

        <div class="setting-row">
            <span class="setting-label">Format:</span>
            <select [(ngModel)]="ayarlar.raporFormati"
                    (ngModelChange)="kaydetAyarlar(ayarlar)">
                <option value="html">HTML Rapor</option>
                <option value="txt">Metin Rapor</option>
                <option value="json">JSON Data</option>
            </select>
        </div>

        <div class="report-buttons">
            <button class="report-btn" [disabled]="!currentReport" (click)="raporIndir('html')">
                <i class="icon file code"></i> HTML
            </button>
            <button class="report-btn" [disabled]="!currentReport" (click)="raporIndir('txt')">
                <i class="icon file text"></i> TXT
            </button>
            <button class="report-btn" [disabled]="!currentReport" (click)="raporIndir('json')">
                <i class="icon database"></i> JSON
            </button>
        </div>
    </div>
</div>

<!-- ═══════════════════════════════════════════════════
     SELECTED ISSUE DETAIL
     ═══════════════════════════════════════════════════ -->
<div *ngIf="selectedIssue" class="issue-detail" [ngClass]="selectedIssue.severity">

    <div class="detail-header">
        <i class="icon" [ngClass]="getSeverityIcon(selectedIssue.severity)"></i>
        {{ selectedIssue.title }}
    </div>

    <div class="detail-row">
        <strong>Aciklama:</strong> {{ selectedIssue.description }}
    </div>

    <div *ngIf="selectedIssue.recommendation" class="detail-row recommendation">
        <strong>Oneri:</strong> {{ selectedIssue.recommendation }}
    </div>

    <div *ngIf="selectedIssue.estimatedCostImpact" class="detail-row cost-impact">
        <strong>Maliyet Etkisi:</strong>
        <span class="impact-value"> +%{{ selectedIssue.estimatedCostImpact }}</span>
    </div>

    <div *ngIf="selectedIssue.affectedFeatures?.length > 0" class="features-row">
        <strong>Etkilenen:</strong>
        <span *ngFor="let f of selectedIssue.affectedFeatures; trackBy: trackByIndex"
              class="feature-badge"
              [class.highlighted]="highlightedFeature === f"
              (click)="onFeatureClick(f)"
              (mouseenter)="onFeatureHover(f)"
              (mouseleave)="onFeatureHover(null)"
              [title]="'Sahnede ' + f + ' vurgula'">
            {{ f }}
        </span>
    </div>
</div>

<!-- FOOTER -->
<div class="dfm-footer">
    <button class="close-btn" (click)="kapa()">
        <i class="icon check"></i> Kapat
    </button>
</div>
